module.exports = ".mat-dialog-content {\n  min-height: 122px;\n}"